<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Devices</a></li>
          <li><a>Upload</a></li>
        </ul>
      </div>
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">File Upload</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>

        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>

        <div *ngIf="!enableDisablePageLoader" class="file-upload-content-container">
          <div class="file-upload-card">
            <div class="section-title">Upload Device File</div>
            <form [formGroup]="fileUploadForm" (ngSubmit)="fileUpload()" novalidate>
              <div class="form-container row">
                <!-- Device Serial No -->
                <div class="col-md-6 col-xs-12 mb-15">
                  <mat-form-field appearance="outline" class="w-100 density-compact">
                    <mat-label>Device Serial No.</mat-label>
                    <mat-select formControlName="serial_number">
                      <mat-option value="" disabled>Select Device Serial No.</mat-option>
                      <mat-option *ngFor="let dev of devices" [value]="dev.serial_number">{{ dev.serial_number }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="(fileUploadFormValidation.serial_number.touched || submitted) && fileUploadFormValidation.serial_number.hasError('required')">
                      <i>Device serial number is required.</i>
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- File Name -->
                <div class="col-md-6 col-xs-12 mb-15">
                  <mat-form-field appearance="outline" class="w-100 density-compact">
                    <mat-label>File Name</mat-label>
                    <input matInput formControlName="fileName" autocomplete="off" placeholder="Enter file name"/>
                    <mat-error *ngIf="(fileUploadFormValidation.fileName.touched || submitted) && fileUploadFormValidation.fileName.hasError('required')">
                      <i>File name is required.</i>
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- File Path -->
                <div class="col-md-6 col-xs-12 mb-15">
                  <mat-form-field appearance="outline" class="w-100 density-compact">
                    <mat-label>File Path</mat-label>
                    <input matInput formControlName="filePath" autocomplete="off" placeholder="Enter file path"/>
                    <mat-error *ngIf="(fileUploadFormValidation.filePath.touched || submitted) && fileUploadFormValidation.filePath.hasError('required')">
                      <i>File path is required.</i>
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- File Data -->
                <div class="col-md-6 col-xs-12 mb-15">
                  <mat-form-field appearance="outline" class="w-100 density-compact">
                    <mat-label>File Data (Encoded Data)</mat-label>
                    <input matInput formControlName="fileData" autocomplete="off" placeholder="Enter file data"/>
                    <mat-error *ngIf="(fileUploadFormValidation.fileData.touched || submitted) && fileUploadFormValidation.fileData.hasError('required')">
                      <i>File data is required.</i>
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Submit Button -->
                <div class="col-xs-12 text-right">
                  <div class="buttons-div reports_search_div d-inline-block">
                    <div class="transactions-button-container">
                      <button type="submit" class="transaction-submit-button" [disabled]="submitting">
                        <span class="icon"><img src="assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                        <span class="text">Submit</span>
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--
  </div>
</div>-->
